import { IOnInit } from "angular";
import { FeesRepo } from "@services/fees.repo";
import { AuthService } from "@common/auth.service";
import { Roles } from "@common/enums/Roles";
import * as moment from "moment";
import { extractErrorMessage } from "@common/utils/errorUtils";
import { DropdownOptionsService } from "@services/clients/dropdownOptions.service";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

class EditPortfolioFeeExclusionDialogController implements IOnInit {
  public exclusion: any;
  public portfolioFeeExclusionForm: ng.IFormController;
  public isLoading: boolean = false;
  public dropdownOptions: any = {};
  public currenciesWithCodes: any[] = [];

  // Editable fields
  public toDate: Date;
  public isActive: boolean;
  public comment: string;
  public cashCurrency: string;
  public cashAmount: number;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private feesRepo: FeesRepo,
    private authService: AuthService,
    private notifyjs: any,
    private dropdownOptionsService: DropdownOptionsService,
    private clientCRMRepo: ClientCRMRepo
  ) {}

  $onInit() {
    if (this.exclusion) {
      this.toDate = this.exclusion.toDate ? new Date(this.exclusion.toDate) : null;
      this.isActive = this.exclusion.isActive;
      this.comment = this.exclusion.comment || '';
      this.cashCurrency = this.exclusion.cashCurrency || null;
      this.cashAmount = this.exclusion.cashAmount || null;
    }

    this.dropdownOptionsService
      .getAllOptions()
      .then((options) => {
        this.dropdownOptions = options;
      })
      .catch((error) => {
        console.warn("Failed to load dropdown options for edit fee exclusion modal:", error);
      });

    this.clientCRMRepo
      .getCurrencies()
      .then((response: any) => {
        this.currenciesWithCodes = response.data || [];
      })
      .catch((error) => {
        console.warn("Failed to load currencies for edit fee exclusion modal:", error);
      });
  }

  getCashCurrencyLabel = (): string => {
    if (!this.cashCurrency || !this.currenciesWithCodes || !this.currenciesWithCodes.length) {
      return "";
    }
    const currency = this.currenciesWithCodes.find((c: any) => c.code === this.cashCurrency);
    return currency ? currency.symbol : "";
  };

  convertToLocaleTime = (date: any): string => {
    if (!date) return '';
    return moment(new Date(date)).format("DD-MM-YYYY");
  };

  isSeniorManager = (): boolean => {
    const userRoles = this.authService.getUserRoles();
    if (!userRoles) return false;
    return (
      userRoles.indexOf(Roles.Accountant) > -1 ||
      userRoles.indexOf(Roles.SystemAdministrator) > -1
    );
  };

  cancel = () => {
    this.$mdDialog.cancel();
  };

  save = () => {
    // Normalize the toDate to UTC
    let actualToDate = null;
    if (this.toDate != null) {
      const toDateObj = this.toDate instanceof Date 
        ? this.toDate 
        : new Date(this.toDate);
      actualToDate = new Date(
        Date.UTC(
          toDateObj.getFullYear(),
          toDateObj.getMonth(),
          toDateObj.getDate()
        )
      );
    }

    const portfolioFeeExclusion = {
      ...this.exclusion,
      toDate: actualToDate,
      isActive: this.isActive,
      comment: this.comment,
      cashCurrency: this.cashCurrency,
      cashAmount: this.cashAmount,
    };

    this.isLoading = true;
    this.feesRepo
      .editPortfolioFeeExclusion(portfolioFeeExclusion)
      .then((res) => {
        this.$mdDialog.hide(portfolioFeeExclusion.portfolioId);
      })
      .catch((err) => {
        this.notifyjs("Failed to update fee exclusion: " + extractErrorMessage(err));
      })
      .finally(() => {
        this.isLoading = false;
      });
  };
}

export const editPortfolioFeeExclusionDialog: angular.IComponentOptions = {
  template: require("./editPortfolioFeeExclusion.dialog.html"),
  controller: EditPortfolioFeeExclusionDialogController,
  bindings: {
    exclusion: "<"
  }
};




// WEBPACK FOOTER //
// ./src/app/fees/clientFeeManagement/editFeeExclusion/editPortfolioFeeExclusion.dialog.ts